/* Runway — global UI: toast, drawer/scrim, burger, search overlay, wishlist.
   Vanilla JS, mirrors the approved prototype's behavior. */
(function () {
  'use strict';

  /* ── Toast ── */
  let toastTimer;
  function toast(msg) {
    const t = document.getElementById('Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('on'), 2600);
  }

  /* ── Focus trap ── */
  const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
  let releaseTrap = null;
  function trapFocus(container) {
    const previous = document.activeElement;
    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      const items = Array.from(container.querySelectorAll(FOCUSABLE)).filter(
        (el) => el.offsetParent !== null
      );
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    document.addEventListener('keydown', onKeydown);
    const target = container.querySelector(FOCUSABLE);
    if (target) target.focus();
    releaseTrap = function () {
      document.removeEventListener('keydown', onKeydown);
      if (previous && previous.focus) previous.focus();
      releaseTrap = null;
    };
  }

  /* ── Bag drawer ── */
  function drawer() { return document.getElementById('CartDrawer'); }
  function scrim() { return document.getElementById('Scrim'); }
  function openDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.add('on');
    d.setAttribute('aria-hidden', 'false');
    if (scrim()) scrim().classList.add('on');
    document.body.style.overflow = 'hidden';
    trapFocus(d);
  }
  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('on');
    d.setAttribute('aria-hidden', 'true');
    if (scrim()) scrim().classList.remove('on');
    document.body.style.overflow = '';
    if (releaseTrap) releaseTrap();
  }

  /* ── Search overlay ── */
  function searchOverlay() { return document.getElementById('SearchOverlay'); }
  function openSearch() {
    const ov = searchOverlay();
    if (!ov) return;
    ov.classList.add('on');
    const input = ov.querySelector('input[type="search"]');
    trapFocus(ov);
    if (input) input.focus();
  }
  function closeSearch() {
    const ov = searchOverlay();
    if (!ov) return;
    ov.classList.remove('on');
    if (releaseTrap) releaseTrap();
  }

  /* ── Wishlist (localStorage only — illustrative, no backend) ── */
  const WISH_KEY = 'runway:wishlist';
  function wishes() {
    try { return new Set(JSON.parse(localStorage.getItem(WISH_KEY) || '[]')); }
    catch (e) { return new Set(); }
  }
  function saveWishes(set) {
    localStorage.setItem(WISH_KEY, JSON.stringify(Array.from(set)));
    syncWishUI(set);
  }
  function syncWishUI(set) {
    set = set || wishes();
    document.querySelectorAll('.wish[data-wish-handle]').forEach((btn) => {
      const on = set.has(btn.dataset.wishHandle);
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      const onIcon = btn.querySelector('[data-wish-on]');
      const offIcon = btn.querySelector('[data-wish-off]');
      if (onIcon) onIcon.hidden = !on;
      if (offIcon) offIcon.hidden = on;
    });
    const count = document.getElementById('WishCount');
    if (count) {
      count.hidden = set.size === 0;
      count.textContent = set.size;
    }
  }

  /* ── Event delegation ── */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close-drawer]') || e.target.id === 'Scrim') {
      closeDrawer();
      return;
    }
    const searchBtn = e.target.closest('[data-open-search]');
    if (searchBtn) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-close-search]')) { closeSearch(); return; }
    const burger = e.target.closest('[data-burger]');
    if (burger) {
      const nav = document.querySelector('nav.main');
      if (nav) {
        const open = nav.classList.toggle('open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    const wishBtn = e.target.closest('.wish[data-wish-handle]');
    if (wishBtn) {
      e.preventDefault();
      const set = wishes();
      const h = wishBtn.dataset.wishHandle;
      if (set.has(h)) set.delete(h); else set.add(h);
      saveWishes(set);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawer(); closeSearch(); }
  });

  document.addEventListener('DOMContentLoaded', () => syncWishUI());
  document.addEventListener('cart:updated', () => syncWishUI());

  window.Runway = { toast, openDrawer, closeDrawer, openSearch, closeSearch, syncWishUI };
})();
